module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Time Range","startDate":"Start date","endDate":"End date"},"it":{"title":"Range Temporale","startDate":"Data di inizio","endDate":"Data di fine"}}')
  delete Component.options._Ctor
}
